import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from 'react';
import api from './api';
const AuthContext = createContext(null);
export const startGoogleLogin = () => {
  sessionStorage.setItem('google-login-started-at', String(Date.now()));
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + '/seller';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null), [loading, setLoading] = useState(true);
  const generation = useRef(0);
  const loadUser = useCallback(async () => {
    const gen = ++generation.current;
    try { const { data } = await api.get('/auth/me'); if (gen === generation.current) setUser(data); }
    catch { if (gen === generation.current) { localStorage.removeItem('bodegon_token'); setUser(null); } }
    finally { if (gen === generation.current) setLoading(false); }
  }, []);
  useEffect(() => {
    if (window.location.hash?.includes('session_id=')) { setLoading(false); return; }
    loadUser();
    return () => { generation.current += 1; };
  }, [loadUser]);
  const completeGoogle = useCallback(async (sessionId) => {
    ++generation.current;
    localStorage.removeItem('bodegon_token');
    const { data } = await api.post('/auth/session', { session_id: sessionId });
    setUser(data.user); setLoading(false); return data.user;
  }, []);
  const passwordAuth = async (path, body) => {
    ++generation.current;
    const { data } = await api.post(path, body);
    localStorage.setItem('bodegon_token', data.token); setUser(data.user); setLoading(false); return data.user;
  };
  const login = (email, password, extra = {}) => passwordAuth('/auth/login', { email, password, ...extra });
  const register = (email, password, full_name, extra = {}) => passwordAuth('/auth/register', { email, password, full_name, ...extra });
  const logout = async () => {
    await api.post('/auth/logout');
    ++generation.current; localStorage.removeItem('bodegon_token'); setUser(null);
  };
  const updateProfile = async (updates) => { const { data } = await api.put('/auth/me', updates); setUser(data); return data; };
  return <AuthContext.Provider value={{ user, loading, login, register, logout, updateProfile, refreshUser: loadUser, completeGoogle, isAuthenticated: !!user, isAdmin: user?.platform_role === 'SUPER_ADMIN' }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => {
  const ctx = useContext(AuthContext); if (!ctx) throw new Error('useAuth must be used within AuthProvider'); return ctx;
};
